/** Local build override. The live switch is AgentTelemetry:Enabled, pushed on InterpreterHub connect. */
export const isAgentNetworkTelemetryForceDisabled = (): boolean => {
  const flag = (process.env.REACT_APP_AGENT_TELEMETRY || '').trim().toLowerCase()
  return flag === 'false' || flag === '0' || flag === 'off'
}
